/**
 * POS maintenance notice for the 28 October 2026 database migration.
 * India window is 12:00–2:30 PM IST. Shown in each country's local time.
 */
export const SUPPORT_OPERATING_HOURS_NOTICE_STORAGE_KEY =
  'support_operating_hours_notice_2026_oct_28';

const CAMPAIGN_START = { y: 2026, m: 10, d: 27 };
const MAINTENANCE_DAY = { y: 2026, m: 10, d: 28 };

const COUNTRY_WINDOWS = {
  ID: {
    offsetMinutes: 7 * 60,
    endHour: 16,
    endMinute: 0,
    timeText:
      'Wednesday, 28 October 2026: 1:30 PM – 4:00 PM (2 hours 30 minutes, WIB)',
  },
  MY: {
    offsetMinutes: 8 * 60,
    endHour: 17,
    endMinute: 0,
    timeText:
      'Wednesday, 28 October 2026: 2:30 PM – 5:00 PM (2 hours 30 minutes, Malaysia Time/MYT)',
  },
} as const;

type NoticeCountry = keyof typeof COUNTRY_WINDOWS;

function noticeCountry(): NoticeCountry {
  const stored = (localStorage.getItem('country') || '')
    .replace(/"/g, '')
    .trim()
    .toUpperCase();
  return stored === 'ID' ? 'ID' : 'MY';
}

function countryWallClock(offsetMinutes: number): {
  y: number;
  m: number;
  d: number;
  minutes: number;
} {
  const shifted = new Date(Date.now() + offsetMinutes * 60 * 1000);
  return {
    y: shifted.getUTCFullYear(),
    m: shifted.getUTCMonth() + 1,
    d: shifted.getUTCDate(),
    minutes: shifted.getUTCHours() * 60 + shifted.getUTCMinutes(),
  };
}

function dateKey(y: number, m: number, d: number): number {
  return y * 10000 + m * 100 + d;
}

export function maintenanceNoticeTimeText(): string {
  return COUNTRY_WINDOWS[noticeCountry()].timeText;
}

export function isSupportOperatingHoursNoticeWindowNow(): boolean {
  const windowForCountry = COUNTRY_WINDOWS[noticeCountry()];
  const now = countryWallClock(windowForCountry.offsetMinutes);
  const nowKey = dateKey(now.y, now.m, now.d);
  const startKey = dateKey(
    CAMPAIGN_START.y,
    CAMPAIGN_START.m,
    CAMPAIGN_START.d
  );
  const dayKey = dateKey(
    MAINTENANCE_DAY.y,
    MAINTENANCE_DAY.m,
    MAINTENANCE_DAY.d
  );
  if (nowKey < startKey || nowKey > dayKey) {
    return false;
  }
  if (nowKey === dayKey) {
    return (
      now.minutes < windowForCountry.endHour * 60 + windowForCountry.endMinute
    );
  }
  return true;
}

/** AI partner hosts (*.easyeat.ai, etc.) and localhost for local dev. */
export function isSupportOperatingHoursHostEligible(): boolean {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return false;
  }
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost') {
    return true;
  }
  return host.endsWith('.ai');
}
